export class CustomAttributes {
  'rating-mpaa': string | null = '';
  'rating-bbfc': string | null = '';
  'episode-xmltv': string | null = '';
  'episode-onscreen': string | null = '';
  'us-parental-ratings': string | null = '';
  'european-fsk-rating': String | number | null = '';
  'network-value': string | null = '';
  'program-type': string | null = '';
  'original-air-date': string | null = '';
  'team-name': string | null = '';
  'league-name': string | null = '';
  'tmsid-episode': string | null = '';
  'tmsid-series': string | null = '';
  actor: string | null = '';
  producer: string | null = '';
  director: string | null = '';
  genre: string | null = '';
  season: string | null = '';
  episode: string | null = '';
  series: string | null = '';

  static Create() {
    const form = new CustomAttributes();
    return form;
  }
  static loadCustomAttributes(data: CustomAttributes) {
    const form = new CustomAttributes();
    form.actor = data.actor;
    form.producer = data.producer;
    form.director = data.director;
    form.genre = data.genre;
    form.season = data.season;
    form.episode = data.episode;
    form.series = data.series;
    form['tmsid-episode'] = data['tmsid-episode'];
    form['tmsid-series'] = data['tmsid-series'];
    form['episode-onscreen'] = data['episode-onscreen'];
    form['episode-xmltv'] = data['episode-xmltv'];
    form['rating-bbfc'] = data['rating-bbfc'];
    form['rating-mpaa'] = data['rating-mpaa'];
    form['us-parental-ratings'] = data['us-parental-ratings'];
    form['european-fsk-rating'] = data['european-fsk-rating'];
    form['network-value'] = data['network-value'];
    form['program-type'] = data['program-type'];
    form['original-air-date'] = data['original-air-date'];
    form['team-name'] = data['team-name'];
    form['league-name'] = data['league-name'];

    return form;
  }
}
